<template>
    <div class="chart-container">

      <div class="Hcp-main-header">
        <div class="main-header-left">
          <span>{{$t('daily')}}</span>
        </div>

        <div class="main-header-right">
          <p>{{$t('date')}}</p>
          <button @click="print"><span>{{$t('print')}}</span></button>
          <div class="block">
            <img src="../../assets/arrow_right.png" @click="prev">
            <el-date-picker v-model="value1" type="date" :placeholder="time"  :picker-options="pickerOptions"
                 :clearable="false"   :editable = false format="dd/MM  yyyy"   @change="getDs">
            </el-date-picker>
            <img src="../../assets/arrow_left.png" @click="next" id="next">
          </div>
        </div>
      </div>

      <hr class="small-hr spe-hr">

      <div >
        <el-row>
            <el-col :span="24">
               <div id="chart1_1" class="graph" ></div>
            </el-col>
        </el-row>
      </div>
      <el-row>
           <el-col :span="24">
               <div id="chart1_2" class="graph" :element-loading-text="loadingText"  v-loading="loading"></div>
           </el-col>
      </el-row>
      <el-row>
            <el-col :span="24">
               <div id="chart1_3" class="graph"></div>
            </el-col>
      </el-row>
      <hr class="small-hr">
      <div class="legend-group" :class="{'zh1':!isEn,'es1':isEs,'it1':isIt,'po1':isPo,'du1':isDu||isCz}">
        <div class="legend"><img src="../../assets/Hcp-icon/legend/Alert.png"><span>{{$t('alert')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/target.png"><span>{{$t('target')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/hypo.png" class="img-spe"> <span>{{$t('hypo')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/SG.png" class="img-spe"><span>{{$t('sensorGlucose')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/calib.png"><span>{{$t('calib')}}</span></div>
        <div class="legend "><img src="../../assets/Hcp-icon/legend/transmitter.png"><span>{{$t('newSen')}}</span></div>
        <div class="legend legend-spe1"  :class="{'zh10':!isEn,'es10':isEs}"><img src="../../assets/Hcp-icon/legend/warm up.png"><span>{{$t('warm')}}</span></div>
        <div class="legend legend-spe8" :class="{'zh2':!isEn,'es2':isEs}"><img src="../../assets/Hcp-icon/legend/basal.png"><span>{{$t('basal')}}</span></div>
        <div class="legend legend-spe9" :class="{'zh3':!isEn,'es3':isEs}"><img src="../../assets/Hcp-icon/legend/temp basal.png"> <span>{{$t('tampBasal')}}</span></div>
        <div class="legend legend-spe3" :class="{'zh4':!isEn,'es4':isEs}"><img src="../../assets/Hcp-icon/legend/normal bolus.png"><span>{{$t('normalBolus')}}</span></div>
        <div class="legend legend-spe4" :class="{'zh5':!isEn}"><img src="../../assets/Hcp-icon/legend/extend bolus.png"><span>{{$t('extendBolus')}}</span></div>
        <div class="legend legend-spe5" :class="{'zh6':!isEn,'es6':isEs}"><img src="../../assets/Hcp-icon/legend/auto suspend.png"><span class="span1">{{$t('manualStop')}}</span></div>
        <div class="legend legend-spe1" :class="{'zh7':!isEn,'es7':isEs}"><img src="../../assets/Hcp-icon/legend/Auto Suspend 2.png"><span class="span1">{{$t('autoStop')}}</span></div>
        <div class="legend legend-spe10" :class="{'zh11':!isEn,'es11':isEs}"><img src="../../assets/Hcp-icon/legend/patch Deactivated.png"><span>{{$t('stop')}}</span></div>
        <div class="legend legend-spe6" :class="{'zh8':!isEn}"><img src="../../assets/Hcp-icon/legend/new Patch.png"> <span>{{$t('newPatch')}}</span></div>
        <div class="legend legend-spe7" :class="{'zh9':!isEn}"><img src="../../assets/Hcp-icon/legend/carbs.png"><span>{{$t('carbs')}}</span></div>
        <div class="legend legend-spe2" :class="{'zh15':!isEn}"><img src="../../assets/Hcp-icon/legend/exercise.png"><span>{{$t('exercise')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/calibrate_1.png"><span>{{$t('BG Reading')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/早餐.png"><span>{{$t('Breakfast')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/中餐.png"><span>{{$t('Lunch')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/晚餐.png"><span>{{$t('Dinner')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/零食.png"><span>{{$t('t1222_Snack')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/运动[30059].png"><span>{{$t('Exercise')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/icon_histogram.png"><span>{{$t('t1222_auto_basal')}}</span></div>
        <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/auto_bolus.png"><span>{{$t('t1222_auto_bolus')}}</span></div>
        <div style="clear: both"></div>
      </div>

      <!-- 增加统计表 -->
      <br/>
      <div class="statics">
        <p>{{$t('statics')}}</p>
        <table class="statics-table" :class="{'de3':isDe}">
          <tr>
            <td colspan="3"  class="td1">{{$t('glucose')}}</td>
            <td rowspan="2" colspan="2" class="td1">{{$t('insulin')}}</td>
            <td rowspan="2" colspan="2" class="td2">{{$t('events')}}</td>
          </tr>
          <tr>
            <td class="td1"></td><td  class="td1">{{$t('BG1')}}</td><td  class="td1">{{$t('SG1')}}</td>
          </tr>
          <tr>
            <td  class="td1">{{$t('Avg')}}{{unit}}{{$t('±SD')}}</td><td  class="td1">{{glucose.bg_avg_dev}}</td><td  class="td1">{{glucose.sg_avg_dev}}</td>
            <td  class="td1"> {{$t('totalDose')}} {{$t('ins_unit')}}</td><td  class="td1">{{insulin.total}}</td>
            <td  class="td1"> {{$t('carbs')}} (g)</td><td class="td2">{{events.carb_total}}</td>
          </tr>
          <tr>
            <td  class="td1">{{$t('min')}}{{unit}}</td><td class="td1">{{glucose.bg_min}}</td><td class="td1">{{glucose.sg_min}}</td>
            <td  class="td1">{{$t('bolus')}} {{$t('ins_unit')}}/%</td><td class="td1">{{insulin.bolus}}</td>
            <td  class="td1"> {{$t('ofMeal')}}</td><td class="td2">{{events.meal_count}}</td>
          </tr>
          <tr>
            <td class="td1">{{$t('max')}}{{unit}}</td><td class="td1">{{glucose.bg_max}}</td><td class="td1">{{glucose.sg_max}}</td>
            <td class="td1">{{$t('basal')}} {{$t('ins_unit')}}/%</td><td class="td1">{{insulin.basal}}</td>
            <td  class="td1">{{$t('avgSD1')}}</td><td class="td2">{{events.meal_avg_sd}}</td>
          </tr>
          <tr>
            <td class="td1">{{$t('target')}} (%)</td><td class="td1">{{glucose.bg_np}}</td><td class="td1">{{glucose.sg_np}}</td>
            <td class="td1">{{$t('foodBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.carb_bolus}}</td>
            <td class="td1">{{$t('totalExerTime')}}</td><td class="td2">{{events.exercise_time}}</td>
          </tr>
          <tr>
            <td class="td1">{{$t('low1')}} (%)</td><td class="td1">{{glucose.bg_lp}}</td><td class="td1">{{glucose.sg_lp}}</td>
            <td class="td1">{{$t('calibBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.corr_bolus}}</td>
            <td class="td1">{{$t('exerNum')}}</td><td class="td2">{{events.exercise_count}}</td>
          </tr>
          <tr>
            <td class="td1">{{$t('high1')}} (%)</td><td class="td1">{{glucose.bg_hp}}</td><td class="td1">{{glucose.sg_hp}}</td>
            <td class="td1"> {{$t('Food+coor')}} {{$t('ins_unit')}}</td><td class="td1">{{foodCoor}}</td>
            <td class="td1"> {{$t('avgInten')}}</td><td class="td2">{{events.exercise_avg_time}}</td>
          </tr>
          <tr>
            <td class="td1">{{$t('ofRead')}}</td><td class="td1">{{glucose.bg_rds_time}}</td><td class="td1">{{glucose.sg_data_num}}</td>
            <td class="td1"> {{$t('normalBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.normal_bolus}}</td>
            <td class="td1"></td><td class="td2"></td>
          </tr>
          <tr>
            <td class="td1">{{$t('ofHypo')}}</td><td class="td1">{{glucose.bg_hypo_rds_time}}</td><td class="td1">{{glucose.sg_hypo_num}}/{{glucose.sg_hypo_duration}}</td>
            <td class="td1">{{$t('extendBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.extent_bolus}}</td>
            <td class="td1"></td><td class="td2"></td>
          </tr>
          <tr>
            <td class="td1">{{$t('ofAlert')}}</td><td class="td1">{{glucose.bg_alarm_cnt}}</td><td class="td1">{{glucose.sg_alarm_cnt}}</td>
            <td class="td1">{{$t('tampBasal')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.temp_basal}}</td>
            <td class="td1"></td><td class="td2"></td>
          </tr>
          <tr>
            <td class="td1"></td><td class="td1"></td><td class="td1"></td>
            <td class="td1">{{$t('durationStop')}}</td><td class="td1">{{insulin.suspend_time}}</td>
            <td class="td1"></td><td class="td2"></td>
          </tr>
          <tr>
            <td class="td3"></td><td class="td3"></td><td class="td3"></td>
            <td class="td3">{{$t('ofPumpAlert')}}</td><td class="td3">{{insulin.pump_alarm_cnt}}</td>
            <td class="td3"></td><td></td>
          </tr>
        </table>
      </div>


      <!-- 自动模式统计 -->
      <br/>
      <div class="statics">
<!--        <p>{{$t('statics')}}</p>-->
        <table class="statics-table auto_mode" :class="{'de3':isDe}">
          <tr>
<!--            <td colspan="3"  class="td1">{{$t('glucose')}}</td>-->
<!--            <td rowspan="2" colspan="2" class="td1">{{$t('insulin')}}</td>-->
            <td rowspan="1" colspan="2" class="td2" style="height: 30px">{{$t('t1222_Auto_Mode')}}</td>
          </tr>
<!--          <tr>-->
<!--            <td class="td1"></td><td  class="td1">{{$t('BG1')}}</td><td  class="td1">{{$t('SG1')}}</td>-->
<!--          </tr>-->
          <tr>
<!--            <td  class="td1">{{$t('Avg')}}{{unit}}{{$t('±SD')}}</td><td  class="td1">{{glucose.bg_avg_dev}}</td><td  class="td1">{{glucose.sg_avg_dev}}</td>-->
<!--            <td  class="td1"> {{$t('totalDose')}} {{$t('ins_unit')}}</td><td  class="td1">{{insulin.total}}</td>-->
            <td  class="td1"> {{$t('t1222_Time_in_Auto_Mode')}}</td>
            <td class="td2">{{timeInAutoMode}}</td>
          </tr>

          <tr>
<!--            <td  class="td1">{{$t('min')}}{{unit}}</td><td class="td1">{{glucose.bg_min}}</td><td class="td1">{{glucose.sg_min}}</td>-->
<!--            <td  class="td1">{{$t('bolus')}} {{$t('ins_unit')}}/%</td><td class="td1">{{insulin.bolus}}</td>-->
            <td  class="td1"> {{$t('t1222_Avg_SD')}}</td>
            <td class="td2">{{autoModeSGAvgSD}} {{glucose_unit}}</td>
          </tr>
          <tr>
<!--            <td class="td1">{{$t('max')}}{{unit}}</td><td class="td1">{{glucose.bg_max}}</td><td class="td1">{{glucose.sg_max}}</td>-->
<!--            <td class="td1">{{$t('basal')}} {{$t('ins_unit')}}/%</td><td class="td1">{{insulin.basal}}</td>-->
            <td  class="td1">{{$t('t1222_Target_Range')}}</td>
            <td class="td2">{{autoModeSGInTargetRange}}</td>
          </tr>
          <tr>
<!--            <td class="td1">{{$t('target')}} (%)</td><td class="td1">{{glucose.bg_np}}</td><td class="td1">{{glucose.sg_np}}</td>-->
<!--            <td class="td1">{{$t('foodBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.carb_bolus}}</td>-->
            <td class="td1">{{$t('t1222_Above_Range')}}</td>
            <td class="td2">{{autoModeSGAboveRange}}</td>
          </tr>
          <tr>
<!--            <td class="td1">{{$t('low1')}} (%)</td><td class="td1">{{glucose.bg_lp}}</td><td class="td1">{{glucose.sg_lp}}</td>-->
<!--            <td class="td1">{{$t('calibBolus')}} {{$t('ins_unit')}}</td><td class="td1">{{insulin.corr_bolus}}</td>-->
            <td class="td1">{{$t('t1222_Below_Range')}}</td>
            <td class="td2">{{autoModeSGBelowRange}}</td>
          </tr>
          <tr>
<!--            <td class="td1">{{$t('high1')}} (%)</td><td class="td1">{{glucose.bg_hp}}</td><td class="td1">{{glucose.sg_hp}}</td>-->
<!--            <td class="td1"> {{$t('Food+coor')}} {{$t('ins_unit')}}</td><td class="td1">{{foodCoor}}</td>-->
            <td class=" td3"> {{$t('t1222_Auto_Mode_Exits')}}</td>
            <td class=" ">{{autoModeExits}}</td>
          </tr>


        </table>
      </div>


    </div>
</template>

<script>
    import * as echarts from 'echarts'
    import auth from '../../auth/auth'
    import B64 from '../../auth/base64'
    import {loading} from '../mixins/loading'
    import format from '@/lib/format'
    import formatClass from '@/lib/chartTipFormat';
    export default {
      mixins: [loading],
      data() {
        return {
          chartWidth: '', timer: false,value1:'',uid:0, et:0,st:0, newBasal:[],stopBasal:[],time:'', unit:'', isMg:'',ts:[],isEs:false,
          sgMax:20,basalMax:5,bolusMax:10,timeSection:[],transmtr:[],carbMax:100,isIt:false,isPo:false,isCz:false,
          sensor_alarm:[], pump_alarm:[],carb:[],exercise:[[10,10,10,10,10]],calib:[],bg:[],
          extend_bolus:[[10,10,10,10,10]],basal_suspend:[],basal_suspend2:[],tempBasal:[],isEn:false,isDu:false,isFr:false,
          autoModeBasal:[[0,0,1]],
          autoModeCorrBolus:[[0,0,1]],
          autoBreakfast:[],
          autoLunch:[],
          autoDinner:[],
          autoSnack:[],
          autoExercise:[],
          sleepTime1:[[10,10,10],[10,10,10]],
          sleepTime2:[[10,10,10],[10,10,10]],
          sleepTime3:[[10,10,10],[10,10,10]],
          chartColumn: null, chartColumn1: null, chartBar: null,
          pickerOptions:{
            disabledDate(time){
              let t1=time.getTime();
              let d2=new Date();
              let t2=d2.getTime();
              //return (t1>t2 || (d2.getYear()-time.getYear())>2 );
              return (t1>t2 || t1<(t2-730*86400*1000));
            }
          },
          textStyle: {
            color: '#282828',
            fontWeight: 'normal',
            fontSize: '14',
            fontFamily: 'SFUIText-Regular'
          },
          titlePadding: [0, 0, 8, 33],
          grid: {x: '3%', y: '16%', width: '92%', height: '73%',},
          sgRange: [['', '4.4', '8.9', '13.3', '17.8', '22.2'], ['', '0.2', '0.4', '0.6', '0.8', '1.0']
            , ['', '1', '2', '3', '4', '5'], ['0', '1', '2', '3', '4', '5'], ['', this.$t('Light'), '', this.$t('Medium'), '', this.$t('heavy')]],
          dateTime: ["00:00", " ", "", "3:00", "", "", "6:00", "", "", "9:00", "", "", "12:00", "", "", "15:00", "",
            "", "18:00", "", "", "21:00", "", "", "24:00",],
          yAxisLabel: {interval: 0, margin: 5, textStyle: {color: '#282828', baseline: 'middle'}, showMinLabel: false},

          glucose:[],insulin:[],events:[],
          foodCoor:'',
          isDe:false,isIt:false,isFr:false,isSw:false,isCz:false,
          //first_request:true,
          timeInAutoMode:'--',
          autoModeSGAvgSD:'--',
          autoModeSGInTargetRange:'--',
          autoModeSGAboveRange:'--',
          autoModeSGBelowRange:'--',
          autoModeExits:0,
          autoModeStat:[],
          glucose_unit:'',
        }
      },
      computed: {
        DataS(){
          return this.$store.state.DataS;
        },
        DataSG(){
          return this.$store.state.DataSG;
        },
        DataBasal(){
          return this.$store.state.DataBasal;
        },
        DataBolus(){
          return this.$store.state.DataBolus;
        },
      },
      methods: {
        getData(){
          // console.log("ds.getData")
          //window.location.reload();
          /* */
          this.et = this.st+86400;
          this.ts = [[this.st,this.et]];
          let param = {
            ts:this.ts,
            tz: parseInt(sessionStorage.getItem('tz')),
            gu:(this.isMg)?'mg/dL':'mmol/L',
          };
          param = B64.base64encode(JSON.stringify(param));
          //if (this.first_request) {
          auth.getDs(this,this.uid,param,0);
        },
        // 获取数据
        getDs(){
          let next = document.getElementById('next');
          if(next.className){
             next.className ='';
          }

          if(this.value1){
            // console.log('getDs:', this.value1, new Date(this.st*1000));
            if (this.st==this.value1.getTime()/1000) {

            } else {
              this.st = this.value1.getTime()/1000;
              this.et = this.st;
              sessionStorage.setItem('st',this.st);
              this.$emit('reload')
              // window.location.reload();
            }

            //this.getData();
          }
        },
        getStatistics(report_data){
          let data =  report_data;
          data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
          this.statics = data;
          this.devices = (data.devices)?data.devices[0]:this.devices;
          this.hb1c = (data.hba1cList)?data.hba1cList:this.hb1c;
          this.glucose = (data.glucose_stat)?data.glucose_stat[0]:this.glucose;
          // console.log( this.glucose)
          this.insulin = (data.insulin_stat)?data.insulin_stat[0]:this.insulin;
          this.foodCoor =(this.insulin.carb_corr_bolus)?(this.insulin.carb_corr_bolus).toFixed(2):0;
          this.events =(data.event_stat)?data.event_stat[0]:this.events;
          // 增加自动模式的字段
          report_data.timeInAutoMode = this.timeInAutoMode;
          //console.log('data:调用了'+this.timeInAutoMode)
          report_data.autoModeSGAvgSD = this.autoModeSGAvgSD;
          report_data.autoModeSGInTargetRange = this.autoModeSGInTargetRange;
          report_data.autoModeSGAboveRange = this.autoModeSGAboveRange;
          report_data.autoModeSGBelowRange = this.autoModeSGBelowRange;
          report_data.autoModeExits = this.autoModeExits;

          //
          sessionStorage.setItem('ds_report_data', JSON.stringify(report_data))
        },
        drawChart1_1() {
          // console.log('this.calib: ', this.calib)
          let that = this;
          this.chart1_1= echarts.init(document.getElementById('chart1_1'));
          this.chart1_1.setOption({
            title: {
              text:(this.isMg)? this.$t('SG')+' (mg/dL)':this.$t('SG')+' (mmol/L)',
              textStyle: this.textStyle,
              padding: this.titlePadding,
            },
            tooltip:{
              trigger:'axis',
              axisPointer:{
                type:'line',
                axis:'x',
                lineStyle:{color:'#333',}
              },
              backgroundColor:'#555',
              textStyle:{
                color: '#ffffff',
              },
              formatter:function(params){
                let tip = format.formatterTip1(params,that);
                return tip ;
              },
            },

            xAxis: [{
              type: 'time',
              boundaryGap: false,
              min:new Date(this.timeSection[0]*1000),
              max:new Date(this.timeSection[1]*1000),
              axisLabel: {show:false,},
              axisLine: {lineStyle: {color: '#ccc'}},
              splitNumber: 24,
              axisPointer:{snap:true}
            }],
            yAxis: [{
              type: 'value',
              min:0,
              max:this.sgMax,
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              boundaryGap: false,
              axisTick: {length: 0},
            }],
            grid: this.grid,
            series: [
              {
              name:'SG',
              type: 'scatter',
              data: this.DataSG,
              markArea: {
                data: [
                  [{yAxis: (this.isMg)?this.DataS.blos_low*18:this.DataS.blos_low}, {yAxis:(this.isMg)?this.DataS.blos_high*18:this.DataS.blos_high}]
                ],
                tooltip:{show:false,
                trigger:'none'},
                itemStyle: {
                  normal: {
                    color: 'rgba(211,255,213,0.6)',
                  }
                }
              },
              markLine: {
                data: [{ yAxis:(this.isMg)?this.DataS.hypo*18:this.DataS.hypo}],
                 symbol:['circle','circle'],
                 silent:true,
                 symbolSize: 1,
                 lineStyle: {normal: {
                    color: 'rgba(255,0,0,0.5)',
                    type: 'solid',
                 }},
                 label:{normal:{show:false}},
              },
              itemStyle: {normal: {
                  color:function (params) {
                       let color = '#2cd200';
                       if(params.value[1]<0.1&&params.value[2]==='H'){
                           color = '#a4a4a4';
                       }
                       else{
                         if(that.isMg){
                           if(params.value[1]>that.DataS.blos_high*18){color = '#e6be00'}
                           if(params.value[1]<that.DataS.blos_low*18){color = '#ff5c5c'}
                         }else{
                           if(params.value[1]>that.DataS.blos_high){color = '#e6be00'}
                           if(params.value[1]<that.DataS.blos_low){color = '#ff5c5c'}
                         }
                       }
                       let type = params.value[2];
                       if((type==='NC'&&params.value[1]==0)||type==='DE'||type==='CE0'||type==='CE1'){
                           color = 'transparent';
                       }
                       return color;
                  }
              }},
              tooltip:{backgroundColor:'#555',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  if(params.value[1]>0){
                    if(params.value[2]==='CX'||params.value[2]==='NC'){
                      return  time[0]+':'+time[1]+', '+params.value[1]+
                        '<hr style="width: 20px;background:#FFF;height:1px;border:none;margin-left: 42px;">';
                    }
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  }
                  else{
                    if(params.value[2]==='NC'){
                      return time[0]+':'+time[1]+', Not Calibrated';
                    }
                    if(params.value[2]==='DE'){
                      return time[0]+':'+time[1]+', No Readings';
                    }
                    if(params.value[2]==='CE0'||params.value[2]==='CE1'){
                      return time[0]+':'+time[1]+',Calib Error';
                    }
                    return time[0]+':'+time[1]+', warm up';
                  }
                },
              },
              symbolSize:2,
              },
              {
                type: 'scatter',
                data: this.bg,
                name:'bg',
                symbol:'image://static/legend/calibrate_1.png',
                symbolSize:10,
                tooltip:{backgroundColor:'#555',
                trigger:'item',
                  formatter:(params)=>{
                    const timeDetail = formatClass.getFormatterTip1TimeDetail(params.value[0]);
                    const tip = timeDetail + formatClass.bgFormat(params, this);
                    return tip;
                  },
                },
                label:{
                show: this.$store.state.glucose_display==='On',
                color: '#114C9A',
                backgroundColor:'#E7F5F9',
                position: 'top',
                distance:10,
                fontSize:16,
                width:40,
                height:20,
                borderColor:'#7AACBF',
                },
                emphasis: {
                  focus: 'self'
                },
              },
              {
                type: 'scatter',
                data: this.calib,
                name: 'calib',
                symbol:'image://static/legend/calib.png',
                tooltip:{backgroundColor:'#555',
                  trigger:'item',
                  z:999,
                  formatter:(params)=>{
                    const timeDetail = formatClass.getFormatterTip1TimeDetail(params.value[0]);
                    const tip = timeDetail + formatClass.calibFormat(params, this);
                    return  tip;
                  },
                },
                label:{
                show: this.$store.state.glucose_display==='On',
                color: '#114C9A',
                backgroundColor:'#E7F5F9',
                position: 'top',
                distance:10,
                fontSize:16,
                width:40,
                height:20,
                borderColor:'#7AACBF',
                },
                emphasis: {
                  focus: 'self'
                },
              },
              {
                type: 'scatter',
                name:'transmtr',
                data: this.transmtr,
                symbol:'rect',
                symbolSize:5,
                itemStyle: {normal: {color: '#00a107'}},
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+'New Sensor';
                  },
                },
              },
              {
                type: 'scatter',
                name:'alarm',
                data: this.sensor_alarm,
                symbol:'image://static/legend/Alert.png',
                symbolSize:13,
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+params.value[2];
                  },
                },
              },
              {
                type: 'custom',
                data:this.sleepTime1,
                z:-1,
                renderItem:function (params,api) {
                  let y = api.value(2);
                  let start = api.coord([api.value(0),y]);
                  let size = api.size([api.value(1)-api.value(0),y]);
                  let style = api.style();
                  return {
                    type:'rect',
                    shape:{
                      x: start[0],
                      y: start[1],
                      width:size[0],
                      height:size[1],
                    },
                    style:style,
                  }
                },
                tooltip:{show:false,},
                itemStyle:{normal: {color: 'rgba(170,170,170,0.2)'}},
              },
            ],
          });
        },
        drawChart1_2() {
          let that=this;
          this.chart1_2 = echarts.init(document.getElementById('chart1_2'));
          this.registLoading('chart1_2',this.chart1_2)
          this.chart1_2.setOption({
            title: [
              {
                text: this.$t('basal')+' '+this.$t('basal_unit'),
              textStyle: this.textStyle,
              padding: this.titlePadding,
            },
              {
                text: this.$t('bolus')+' '+this.$t('ins_unit'),
              textStyle: this.textStyle,
              right: '18',
            },
            ],
            tooltip:{
               trigger:'axis',
               axisPointer:{
                 type:'line',
                 axis:'x',
                 lineStyle:{color:'#333',}
               },
               backgroundColor:'#555',
               textStyle:{
                color: ' #ffffff',
                },
               formatter:function(params){
                   let tip = format.formatterTip(params, that, 'chart1');
                   return tip ;
               },
            },
            xAxis: [{
              type: 'time',
              boundaryGap: false,
              min:new Date(this.timeSection[0]*1000),
              max:new Date(this.timeSection[1]*1000),
              interlval:0,
              axisLabel: {show:false,},
              axisLine: {lineStyle: {color: '#ccc'}},
              splitNumber: 24,
            }],
            yAxis: [
                {
              type:'value',
              boundaryGap: false,
              min:0,
              max:this.basalMax,
              axisTick: {length: 0},
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
            }, {
              type:'value',
              boundaryGap: false,
              min:0,
              max:this.bolusMax,
              axisTick: {length: 0},
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              splitLine:{show:false,},
            }
            ],
            grid: this.grid,
            series: [
              {
                type: 'line',
                name:this.$t('basal'),
                data:this.DataBasal,
                itemStyle: {normal: {color: '#00ff40'}},
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  },
                },
                symbolSize:2,
              },
              {
                type: 'line',
                name:this.$t('auto suspend'),
                data:this.basal_suspend,
                itemStyle: {normal: {color: '#ff0000'}},
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+params.value[2];
                  },
                },
                lineStyle:{normal:{type:'dashed'}},
                symbolSize:1,
              },
              {
                type: 'line',
                name:this.$t('tempBasal'),
                data:this.tempBasal,
                itemStyle: {normal: {color:  '#00ff40'}},
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+'TempBasal: '+params.value[1];
                  },
                },
                lineStyle:{normal:{type:'dashed'}},
                symbolSize:1,
              },
              {
                type: 'line',
                name:this.$t('manualStop'),
                data:this.basal_suspend2,
                itemStyle: {normal: {color: '#ff0000'}},
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+'Manual Suspend';
                  },
                },
                symbolSize:1,
              },
              // 正常大剂量
              {
                type: 'custom',
                name:this.$t('normalBolus'),
                data:this.DataBolus,
                z:999,
                yAxisIndex:1,
                itemStyle: {normal: {color: '#182f82'}},
                renderItem: function (params, api) {
                  let y = api.value(1);
                  let start = api.coord([api.value(0),y]);
                  let size = api.size([600000,y]);
                  let style = api.style()
                  // if(auth.showSuggest(api.value(1),api.value(3))){
                  //   style.fill = 'red'
                  // }
                  return {
                    type:'rect',
                    shape:{
                      x: start[0],
                      y: start[1],
                      width:size[0],
                      height:size[1],
                    },
                    style:style,
                  }
                },
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    // let tip =
                    //console.log('arguments: ', arguments)
                    return time[0]+':1125254'+time[1]+', '+params.value[2]+': '+params.value[1]+ins_unit2;
                  },
                },
                barWidth:'4',
              },
              {
                type: 'custom',
                name:this.$t('extendBolus'),
                data:this.extend_bolus,
                yAxisIndex:1,
                renderItem:function (params,api) {
                  let y = api.value(2);
                  let start = api.coord([api.value(0),y]);
                  let size = api.size([api.value(1)-api.value(0),y]);
                  let style = api.style();
                  return {
                    type:'rect',
                    shape:{
                      x: start[0],
                      y: start[1],
                      width:size[0],
                      height:size[1],
                    },
                    style:style,
                  }
                },
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return time[0]+':'+time[1]+', '+params.value[4]+': '+params.value[2]+ins_unit2+'/'+params.value[3]+'min';
                  },
                },
                itemStyle:{normal: {color: '#f9b4ff'},emphasis:{color: '#f9b4ff'}},
              },
              {
                type: 'scatter',
                name:this.$t('newPatch'),
                data:this.newBasal,
                symbol:'image://static/legend/new%20Patch.png',
                symbolSize:10,
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+',New Patch ';
                  },
                },
              },
              {
                type: 'scatter',
                name:this.$t('stop'),
                data:this.stopBasal,
                symbol:'image://static/legend/patch%20Deactivated.png',
                symbolSize:8,
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', Delivery Stop';
                  },
                },
              },
              {
                type: 'scatter',
                name:this.$t('alert'),
                data: this.pump_alarm,
                symbol:'image://static/legend/Alert.png',
                symbolSize:13,
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+params.value[2];
                  },
                },
              },
              {
                type: 'custom',
                data:this.sleepTime2,
                z:-1,
                renderItem:function (params,api) {
                  let y = api.value(2);
                  let start = api.coord([api.value(0),y]);
                  let size = api.size([api.value(1)-api.value(0),y]);
                  let style = api.style();
                  return {
                    type:'rect',
                    shape:{
                      x: start[0],
                      y: start[1],
                      width:size[0],
                      height:size[1],
                    },
                    style:style,
                  }
                },
                tooltip:{show:false,},
                itemStyle:{normal: {color: 'rgba(170,170,170,0.2)'},emphasis:{show:false}},
              },
              {
                type: 'custom',
                name:this.$t('t1222_autoModeBasal'),
                data:this.autoModeBasal,
                yAxisIndex:0,
                renderItem:function (params,api) {
                  let y = api.value(2);
                  let start = api.coord([api.value(0),y]);
                  let size = api.size([api.value(1)-api.value(0),y]);
                  let style = api.style();
                  // console.log('params1:', api.value(1)-api.value(0), size);
                  return {
                    type:'rect',
                    shape:{
                      x: start[0],
                      y: start[1],
                      width:size[0],
                      height:size[1],
                    },
                    // style:style,
                    style:{
                      fill:'rgba(0, 255, 76, 0.5)',
                    }
                  }
                },
                tooltip:{backgroundColor:'#333',
                  // formatter:function(params){
                  //   let date = params.value[0];
                  //   let time = format.formatterDate5(date);
                  //   return time[0]+':'+time[1]+', '+params.value[4]+': '+params.value[2]+ins_unit2+'/'+params.value[3]+'min';
                  // },
                },
                itemStyle:{normal: {color: '#00ff4c'},emphasis:{color: '#00ff5c'}},
              },
              {
                type: 'custom',
                data:this.autoModeCorrBolus,
                name:this.$t('t1222_autoModeCorrBolus'),             // index 11
                yAxisIndex:1,
                itemStyle: {normal: {color: '#009bff'}},
                renderItem:function (params,api) {
                  let y = api.value(2) + api.value(1);
                  let start = api.coord([api.value(0),y]);
                  let size = api.size([600000,y]);
                  let style = api.style();
                  return {
                    type:'rect',
                    shape:{
                      x: start[0],
                      y: start[1],
                      width:size[0],
                      height:size[1],
                    },
                    style:style,
                  }
                },
                barWidth:'4',
              },
              // 与建议值不符时显示
              // {
              //   type: 'scatter',
              //   data: this.suggest,
              //   symbol:'image://static/legend/calibrate_1.png',
              //   tooltip:{backgroundColor:'#333',
              //     formatter:function(params){
              //       let date = params.value[0];
              //       let time = format.formatterDate5(date);
              //       return  time[0]+':'+time[1]+',BG '+params.value[1];
              //     },
              //   },
              // },
            ]
          });
        },
        drawChart1_3() {
          let s_breakfast = this.$t('Breakfast')
          let s_lunch = this.$t('Lunch')
          let s_dinner = this.$t('Dinner')
          let s_snack = this.$t('t1222_Snack')
          let s_exercise = this.$t('Exercise')
          let that=this;
          this.chart1_3 = echarts.init(document.getElementById('chart1_3'));
          this.chart1_3.setOption({
            title: [
              {
                text: this.$t('carbs')+' ('+this.$t('g')+')',
                textStyle: this.textStyle,
                left: this.titleLeft,
                padding: this.titlePadding,
              },
              {
                text: this.$t('exercise'),
                textStyle: this.textStyle,
                right: '22',
              }
            ],
            tooltip:{
              backgroundColor:'#555',
              borderColor:'#333',
              padding:2,
              textStyle:{
                color: ' #ffffff',
              },
            },
            xAxis: [{
              type: 'time',
              boundaryGap: false,
              min:new Date(this.timeSection[0]*1000),
              max:new Date(this.timeSection[1]*1000),
              axisLabel:{
                showMaxLabel:true,
                margin: 10, textStyle: {color: '#282828', baseline: 'middle'} ,
                formatter:function (value,index) {
                  // let H = new Date(value).getHours();
                  index = (value-that.timeSection[0]*1000) / 3600000;
                  let H=index;
                  if(index<24){
                    if(index%3===0){
                      H = H<10 ? ('0'+H+':00' ): H+':00';
                      return  H;
                    }else{
                      return ' ';
                    }
                  }else{
                    return '24:00';
                  }
                }
              },
              axisLine: {lineStyle: {color: '#ccc'}},
              splitNumber: 24,
            }],
            yAxis: [
              {
              type: 'value',
              axisLabel: this.yAxisLabel,
                axisLine:{lineStyle:{color:'#ccc'}},
              min:0,
              max:this.carbMax,
              boundaryGap: false,
              splitLine: {show: true,},
              axisTick: {length: 0},
            }, {
              data: this.sgRange[4],
              boundaryGap: false,
              axisTick: {length: 0},
              axisLabel:  this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
            }],
            grid: this.grid,
            series: [
              {
                type: 'custom',
                data:this.sleepTime3,
                z:-1,
                renderItem:function (params,api) {
                  let y = api.value(2);
                  let start = api.coord([api.value(0),y]);
                  let size = api.size([api.value(1)-api.value(0),y]);
                  let style = api.style();
                  return {
                    type:'rect',
                    shape:{
                      x: start[0],
                      y: start[1],
                      width:size[0],
                      height:size[1],
                    },
                    style:style,
                  }
                },
                tooltip:{show:false,},
                itemStyle:{normal: {color: 'rgba(170,170,170,0.2)'}},
              },
              {
                type: 'custom',
                data:this.exercise,
                renderItem:function (params,api) {
                  let y = api.value(2);
                  let start = api.coord([api.value(0),y]);
                  let size = api.size([api.value(1)-api.value(0),y]);
                  let style = api.style();
                  return {
                    type:'rect',
                    shape:{
                      x: start[0],
                      y: start[1],
                      width: size[0],
                      height: size[1],
                    },
                    style:style,
                  }
                },
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+params.value[3]+'min, '+params.value[4];
                  },
                },
                itemStyle: {normal: {color: '#009bff'},emphasis:{color: '#009bff'}},
              },
              {
                type: 'scatter',
                data: this.carb,
                symbol:'rect',
                symbolSize:[29,18],
                itemStyle: {normal: {color: '#00ff4c'},emphasis:{color: '#00ff4c'}},
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+params.value[1]+'g';
                  },
                },
              },
              {
                type: 'scatter',
                name:this.$t('t1222_autoSnack'),
                data:this.autoSnack,
                symbol:'image://static/legend/automode/零食.png',
                symbolSize:[29,18],
                symbolOffset:[0,-10],
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    //console.log('snack tip.');
                    return  time[0]+':'+time[1]+', '+s_snack;
                  },
                },
              },
              {
                type: 'scatter',
                name:this.$t('t1222_autoBreakfast'),
                data:this.autoBreakfast,
                symbol:'image://static/legend/automode/早餐.png',
                symbolSize:[29,18],
                symbolOffset:[0,-10],
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+s_breakfast;
                  },
                },
              },
              {
                type: 'scatter',
                name:this.$t('t1222_autoLunch'),
                data:this.autoLunch,
                symbolOffset:[0,-10],
                symbol:'image://static/legend/automode/中餐.png',
                symbolSize:[29,18],
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+s_lunch;
                  },
                },
              },
              {
                type: 'scatter',
                name:this.$t('t1222_autoDinner'),
                data:this.autoDinner,
                symbol:'image://static/legend/automode/晚餐.png',
                symbolSize:[29,18],
                symbolOffset:[0,-10],
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+s_dinner;
                  },
                },
              },
              {
                type: 'scatter',
                name:this.$t('t1222_autoExercise'),
                data:this.autoExercise,
                symbol:'image://static/legend/automode/运动[30059].png',
                symbolSize:[29,18],
                symbolOffset:[0,-10],
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    //console.log('Exercise tip:', time);
                    return  time[0]+':'+time[1]+', '+s_exercise;
                  },
                },
              },

            ]
          });

        },
        drawCharts(i) {
          this.drawChart1_1();
          this.drawChart1_2();
          this.drawChart1_3();
        },
        chartsDispose(){
          this.chart1_1.dispose();
          this.chart1_2.dispose();
          this.chart1_3.dispose();
        },
        handleResize(){
          let win = window.innerWidth;
          let scale = (win<1500)?0.91:0.62;
          const chartWidth = win * scale * 0.98 * 0.96 + 'px';
          let chart1_1 = document.getElementById('chart1_1');
          let chart1_2 = document.getElementById('chart1_2');
          let chart1_3 = document.getElementById('chart1_3');
          if(chart1_3){
            chart1_1.style.width = chartWidth;
            chart1_2.style.width = chartWidth;
            chart1_3.style.width = chartWidth;
          }
        },
        prev(){
          let time = (this.value1)?this.value1.getTime()/1000:this.st;
          //time = time - 86400;
          let cur_date=new Date(time*1000);
          let prev_date=new Date(cur_date.getFullYear(), cur_date.getMonth(), cur_date.getDate()-1)
          this.value1=prev_date;
          //time=prev_date/1000;
          //this.value1 =new Date(time*1000);
        },
        next(e){
          let now =new Date().setHours(0,0,0,0)/1000;
          let time = (this.value1)?this.value1.getTime()/1000:this.st;
          //let next = time + 86400;
          let cur_date=new Date(time*1000);
          let next_date=new Date(cur_date.getFullYear(), cur_date.getMonth(), cur_date.getDate()+1)
          let next=next_date/1000;
          if(next>now){
              e.target.className='next';
          }else{
            this.value1 =new Date(next*1000);
          }
        },
        print(){
          let src1 = this.chart1_1.getDataURL();
          let src2 = this.chart1_2.getDataURL();
          let src3 = this.chart1_3.getDataURL();
          sessionStorage.setItem('src1_1',src1);
          sessionStorage.setItem('src1_2',src2);
          sessionStorage.setItem('src1_3',src3);
          window.open('/#/chart1-print','_blank');
        }
      },
      beforeDestroy(){
        if(this.chart1_1){
            this.chartsDispose();
        }
        this.chart1_1 = null;
        this.chart1_2 = null;
        this.chart1_3 = null;
        this.$store.commit('updateDataSG',[]);
        sessionStorage.removeItem('flagg')
      },
      mounted: function () {
          let lang = sessionStorage.getItem('language');
          this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
          this.isDe = (lang==='de')?true:false;
          this.isEs = (lang==='es')?true:false;
          this.isIt = (lang==='it')?true:false;
          this.isPo = (lang==='po')?true:false;
          this.isDu = (lang==='du')?true:false;
          this.isFr = (lang==='fr')?true:false;
          this.isCz = (lang==='cz')?true:false;
          this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
          this.unit = (this.isMg)?' (mg/dL)':' (mmol/L)';
          this.glucose_unit = (this.isMg)?'mg/dL':'mmol/L';
          this.sgMax = (this.isMg)? 400:25;

          if(sessionStorage.getItem('userType')!=='P'){
            this.uid = parseInt(sessionStorage.getItem('patientId'));
          }else{
            this.uid = parseInt(sessionStorage.getItem('uid'));
          }
          if(!sessionStorage.getItem('st')){
            var et=new Date().setHours(0,0,0,0)/1000;
            var nd=new Date();
            var cur_day=new Date(nd.getFullYear(), nd.getMonth(), nd.getDate())
            var chart_end_time=sessionStorage.getItem('chart_end_time')

            for (var d=0; d<3000;d++) {
              if (et>chart_end_time) {
                cur_day=new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate()-1)
                //et -= 24*3600;                                          
                et=cur_day/1000;
              } else {
                break;
              }
            }
            this.st= et;
          }else{
            this.st = parseInt(sessionStorage.getItem('st'));
          }
          this.value1=new Date(this.st*1000);
          this.et = this.st+86400;
          sessionStorage.setItem('st',this.st);
          this.time =format.formatterDate4(this.st);
          this.ts = [[this.st,this.et]];
          let param = {
            ts:this.ts,
            tz: parseInt(sessionStorage.getItem('tz')),
            gu:(this.isMg)?'mg/dL':'mmol/L',
          };
          param = B64.base64encode(JSON.stringify(param));
          //auth.getDs(this,this.uid,param,0);
          if(!sessionStorage.getItem('flagg')){
            this.getData();
            sessionStorage.setItem('flagg', 1)
          }

          let that=this;
        /*auth.getDataMap(this, this.uid, function (res) {
          //console.log(res);
          //console.log(param);
          if (0!=res.error) {
            return;
          }
          var end_time=(res.end.cgms > res.end.pump)?res.end.cgms:res.end.pump;

          var ts=param.ts[0];
          for(var d=0; d<3000; d++) {
            if (ts[1]>end_time) {
              ts[0] -= 24*3600;
              ts[1] -= 24*3600;
            } else {
              break;
            }
          }

          ts[0] += 24*3600;
          ts[1] += 24*3600;

          that.time =format.formatterDate4(ts[0]);
          //console.log(param);
          param = B64.base64encode(JSON.stringify(param));
          auth.getDs(that, that.uid, param, 0);
        });*/

          window.onresize = function () {
            that.handleResize();
            if(that.chart1_1){
              that.chart1_1.resize();
              that.chart1_2.resize();
              that.chart1_3.resize();
            }
          }
        }

    }
</script>

<style scoped>
    .chart-container {
        width:100%;
        height:1380px;
        float: left;
        font-family:SFUIText-Regular;
        font-size:14px;
        color:#282828;
        letter-spacing:-0.34px;
    }
    .Hcp-main-header{
      width:97%;
      height:40px;
      margin:0 auto;
      font-family:SFUIText-Regular;
      font-size:18px;
      color:#282828;
    }
    .main-header-left{
      float: left;
      height:20px;
      line-height: 20px;
      margin-top:10px;
      border-left: 2px solid #005dac;
    }
    .main-header-left span{
      margin-left:10px;
    }
    .main-header-right{
      float: right;
      width:380px;
      height:30px;
      line-height: 30px;
    }
    .main-header-right p{
      float: left;
      margin-right:15px;
      margin-top:2px;
    }
    .main-header-right button{
      float: right;
      border-radius:100px;
      box-shadow:0 3px 4px 0 #e8f3ff;
      background: #fff;
      border: 1px solid #a3a3a3;
      outline: none;
      margin-top:4px;
      width:110px;
      height:26px;
      line-height: 26px;
      cursor: pointer;
      margin-right: 3.5%;
    }
    .main-header-right span{
      font-size:16px;
      font-family:SFUIText-Regular;
      letter-spacing:-0.39px;
      *margin:0 35px;
    }
    .block{
      height:35px;
      line-height: 35px;
    }
    .block img{
      margin:-2px 8px ;
      cursor: pointer;
      display:inline-block;
      height:16px;
      width: 11px;
    }
    .block .next{
      opacity: 0.4;
    }
    .el-date-editor.el-input{
      width:125px;
      cursor: auto;
    }


    .small-hr{
      background:#e6e8ea;
      width:97%;
      height:1px;
      margin:10px auto 20px;
      border:none;
    }
    .spe-hr{
      margin-bottom:20px ;
    }
    .chart-container .graph{
      width:100%;
      height:170px;
      margin-bottom: 5px;
    }
    .legend-group{
      width:96%;
      margin:0 auto;
      font-family:SFUIText-Regular;
      font-size:16px;
      color:#282828;
      letter-spacing:-0.39px;
      text-align:left;
    }
    .legend{
      float:left;
      margin-bottom: 8px;
      margin-right:60px;
      height:20px;
      line-height: 20px;
    }
    .zh1 .legend{
      margin-right:70px;
    }
    .es1 .legend{
      margin-right:40px;
    }
    .legend img{
      margin-right: 8px;
    }
    .legend-spe1{
      margin-right: 44px;
    }
    .legend-spe8{
      margin-right: 43px;
    }
    .legend-spe9{
      margin-right: 32px;
    }
    .legend-spe10{
      margin-right: 22px;
    }
    .zh1 .zh2{
      margin-right: 44px;
    }
    .es1 .es2{
      margin-right: 30px;
    }
    .zh1 .zh3{
      margin-right: 58px;
    }
    .es1 .es3{
      margin-right: 20px;
    }
    .zh1 .zh4{
      margin-right: 35px;
    }
    .es1 .es4{
      margin-right: 8px;
    }
    .es4 img{
      margin-right: 2px;
    }

    .zh1 .zh5{
      margin-right:50px;
    }
    .zh1 .zh6{
      margin-right:28px;
    }
    .es1 .es6{
      margin-right:15px;
    }
    .es1 .es7{
      margin-right:15px;
    }
    .es1 .es11{
      margin-right:15px;
    }
    .zh1 .zh7{
      margin-right:55px;
    }
    .zh1 .zh8{
      margin-right:55px;
    }
    .zh1 .zh9{
      margin-right:116px;
    }
    .zh1 .zh15{
      margin-right:89px;
    }
    .legend-spe2{
      *margin-bottom: 13px;
    }
    .legend-spe3{
      margin-right: 18px;
    }
    .legend-spe4{
      margin-right: 53px;
    }
    .legend-spe5{
      margin-right: 15px;
    }
    .legend-spe6{
      margin-right: 30px;
    }
    .legend-spe7{
      margin-right: 85px;
    }
    .legend-group .span1{
      margin-bottom: 2px;
      display: block;
      float: right ;
    }
    .img-spe{
      margin-bottom: 4px;
    }
    .it1 .legend{
      margin-right:40px;
    }
    .po1 .legend{
      margin-right:40px;
    }
    .du1 .legend{
      margin-right:40px;
    }

    .statics{
      clear: both;
    }
    .statics p{
      font-family:SFUIText-Regular;
      font-size:16px;
      color:#282828;
      letter-spacing:-0.27px;
      margin-left: 4%;
    }
    .statics-table{
      width: 94%;
      margin:10px auto 0;
      border:1px solid #747474;
      font-family:SFUIText-Regular;
      border-collapse: collapse;
      text-align:center;
      table-layout: fixed;
    }
    .statics-table.auto_mode {
      width: 50%;
      margin-left:3%;
    }
    .de3{
      word-break: break-all;
      word-wrap: break-word;
    }
    .statics-table td{
      height:15px;
    }
    .statics-table .td1{
      border-bottom:1px solid rgba(116,116,116,0.34);
      border-right:1px solid rgba(116,116,116,0.34);
    }
    .statics-table .td2{
      border-bottom:1px solid rgba(116,116,116,0.34);
    }
    .statics-table .td3{
      border-right:1px solid rgba(116,116,116,0.34);
    }

    @media screen and (max-width: 1300px){
      .legend{
        margin-right:48px;
      }
      .legend-spe8{
        margin-right: 30px;
      }
      .legend-spe9{
        margin-right: 15px;
      }
      .legend-spe3{
        margin-right: 12px;
      }
      .legend-spe4{
        margin-right: 38px;
      }
      .legend-spe5{
        margin-right: 5px;
      }
      .legend-spe1{
        margin-right: 30px;
      }
      .legend-spe10{
        margin-right: 5px;
      }
      .legend-spe6{
        margin-right: 20px;
      }
      .legend-spe7{
        margin-right: 63px;
      }
      .zh1 .zh10{
        margin-right: 34px;
      }
      .es1 .legend{
        margin-right: 25px;
      }
      .es1 .es10{
        margin-right: 14px;
      }
      .zh1 .zh11{
        margin-right: 24px;
      }
      .po1 .legend{
        margin-right:30px;
      }
      .du1 .legend{
        margin-right:30px;
      }
    }
</style>





// WEBPACK FOOTER //
// chart1.vue?34cafb83